/**
  * 登录模块接口列表
  */

 import base from './base'; // 导入接口域名列表
 import axios from '@/axios'; // 导入axios实例
 import qs from 'qs'; // 根据需求是否导入qs模块
 const baseUrl = base.default;

 const login = {
    //获取用户实名信息
    getRealNameInfo(params,errorNotTips,tokenInvalidNotSkiptoLogin){
        return axios({
            method: 'post',
            url: `${baseUrl}/user/getRealNameInfo`,
            params: params,
            headers: {
                'errorNotTips':errorNotTips,
                'tokenInvalidNotSkiptoLogin':tokenInvalidNotSkiptoLogin,
            }
        })
    },
    //保存用户实名信息
    saveRealNameInfo(params){
        return axios.post(`${baseUrl}/user/saveRealNameInfo`,qs.stringify(params));
    },
    //更新用户信息
    updateLoginInfo(params){
        return axios.post(`${baseUrl}/login/updateLoginInfo`,qs.stringify(params));
    },

    //查询证书列表
    getUserCertificateList(params,errorNotTips,tokenInvalidNotSkiptoLogin){
        return axios({
            method: 'post',
            url: `${baseUrl}/studioEvaluation/getUserCertificateList`,
            params: params,
            headers: {
                'errorNotTips':errorNotTips,
                'tokenInvalidNotSkiptoLogin':tokenInvalidNotSkiptoLogin,
            }
        })
    },

    //查询证书详情
    getUserCertificateDetail(params){
        return axios.post(`${baseUrl}/studioEvaluation/getUserCertificateDetail`,qs.stringify(params));
    },
    //上传证书
    uploadCertificate(params){
        return axios.post(`${baseUrl}/studioEvaluation/uploadCertificate`,qs.stringify(params));
    },

    //根据token获取登录信息
    getLoginInfo(params,errorNotTips,tokenInvalidNotSkiptoLogin){
        return axios({
            method: 'post',
            url: `${baseUrl}/login/getLoginInfo`,
            params: params,
            headers: {
                'errorNotTips':errorNotTips,
                'tokenInvalidNotSkiptoLogin':tokenInvalidNotSkiptoLogin,
            }
        })
    },
    //获取用户信息
    userGetUserInfo(params,errorNotTips,tokenInvalidNotSkiptoLogin){
        return axios({
            method: 'post',
            url: `${baseUrl}/user/getUserInfo`,
            params: params,
            headers: {
                'errorNotTips':errorNotTips,
                'tokenInvalidNotSkiptoLogin':tokenInvalidNotSkiptoLogin,
            }
        })
    },
    //更新用户信息
    userUpdateUserInfo(params){
        return axios.post(`${baseUrl}/user/updateUserInfo`,qs.stringify(params));
    },
    //删除个人风采
    userDelTeacherShine(params){
        return axios.post(`${baseUrl}/user/delTeacherShine`,qs.stringify(params));
    },
    //添加个人风采
    userAddTeacherShine(params){
        return axios.post(`${baseUrl}/user/addTeacherShine`,qs.stringify(params));
    },
    //获取用户专业信息
    majorGetUserMajors(params){
        return axios.post(`${baseUrl}/major/getUserMajors`,qs.stringify(params));
    },
    //删除用户专业信息
    majorDeleteUserMajor(params){
        return axios.post(`${baseUrl}/major/deleteUserMajor`,qs.stringify(params));
    },
    //添加用户专业信息
    majorAddUserMajor(params){
        return axios.post(`${baseUrl}/major/addUserMajor`,qs.stringify(params));
    },
    //设置默认专业
    majorSetDefaultMajor(params){
        return axios.post(`${baseUrl}/major/setDefaultMajor`,qs.stringify(params));
    },
    //查询一级专业
    selectFirstDic(params){
        return axios.post(`${baseUrl}/dictionary/selectFirstDic`,qs.stringify(params));
    },
    //查询个人风采列表
    getTeacherShineAttachList(params,errorNotTips,tokenInvalidNotSkiptoLogin){
        return axios({
            method: 'get',
            url: `${baseUrl}/user/getTeacherShineAttachList`,
            params: params,
            headers: {
                'errorNotTips':errorNotTips,
                'tokenInvalidNotSkiptoLogin':tokenInvalidNotSkiptoLogin,
            }
        })
    },
    //获取用户信息
    getUserInfo(params,errorNotTips,tokenInvalidNotSkiptoLogin){
        return axios({
            method: 'post',
            url: `${baseUrl}/user/getUserInfo`,
            params: params,
            headers: {
                'errorNotTips':errorNotTips,
                'tokenInvalidNotSkiptoLogin':tokenInvalidNotSkiptoLogin,
            }
        })
    },
    
 }
 
 export default login;